import { useCallback, useEffect, useState, useRef } from "react";
import { useLazyQuery } from "@apollo/client";
import { calculateMinPriceQuery } from "../queries";

export function useRvPriceTotalTableInfo() {
  const [cache, setCache] = useState({});
  const [modalState, setModalState] = useState({ show: false, rvId: null, priceForm: null });
  const fetchRef = useRef();

  const [fetchCalculateMinPrice, { loading }] = useLazyQuery(
    calculateMinPriceQuery,
    {
      fetchPolicy: "no-cache",
      onCompleted: (response) => {
        const { rvId } = fetchRef.current || {};
        const price = response?.calculate_min_price?.price;
        const price_per_night = response?.calculate_min_price?.price_per_night;
        const nights = response?.calculate_min_price?.nights;
        const priceForm = response?.calculate_min_price?.price_form;
        if (rvId) {
          setCache(prev => ({
            ...prev,
            [rvId]: {
              priceForm,
              price,
              price_per_night,
              nights
            }
          }));
          setModalState({ show: true, rvId, priceForm });
        } else {
          setModalState({ show: false, rvId: null, priceForm: null });
          console.error("Error fetching price form:");
        }
      }
    }
  );

  const onPriceTotalClick = useCallback((e, dates = undefined, rentalType) => {
    const id = e?.detail?.id;
    if (!id) return;
    if (false) {
    // if (cache[id]) {
      setModalState({ show: true, rvId: id, priceForm: cache[id].priceForm });
    } else {
      setModalState({ show: false, rvId: id, priceForm: null });
      fetchRef.current = { rvId: Number(id) };
      fetchCalculateMinPrice({
        variables: {
          rv: Number(id),
          ...(dates || {}),
          ...(typeof rentalType === "number" ? { rental_type: rentalType } : {})
        }
      });
    }
  }, [cache, fetchCalculateMinPrice]);

  useEffect(() => {
    window.addEventListener("rv-card-price-total-click", onPriceTotalClick);
    return () => {
      window.removeEventListener("rv-card-price-total-click", onPriceTotalClick);
    };
  }, [onPriceTotalClick]);

  const handleClose = useCallback(
    () => setModalState({ show: false, rvId: null, priceForm: null }),
    []
  );

  const currentCache = modalState.rvId ? cache[modalState.rvId] || {} : {};
  const { price, price_per_night, nights } = currentCache;

  return { onPriceTotalClick, loading, modalState, handleClose, price, price_per_night, nights };
}
